import customer from './customer'
export default customer
